import React from "react";
import { Badge } from "reactstrap";

import { currencyFormatter } from "utils/formatter";

export const STATUS_META = {
  active: { color: "success", label: "Active" },
  scheduled: { color: "info", label: "Scheduled" },
  expired: { color: "secondary", label: "Expired" },
  exhausted: { color: "warning", label: "Fully used" },
  disabled: { color: "dark", label: "Disabled" },
  archived: { color: "danger", label: "Archived" },
};

export const StatusBadge = ({ status }) => {
  const meta = STATUS_META[status] || STATUS_META.disabled;
  return (
    <Badge color={meta.color} className="text-white">
      {meta.label}
    </Badge>
  );
};

// Codes made before the type existed have none, and are public.
export const TYPE_META = {
  public: { color: "primary", label: "Public" },
  pos: { color: "dark", label: "POS" },
};

export const TypeBadge = ({ type }) => {
  const meta = TYPE_META[type] || TYPE_META.public;
  return (
    <Badge color={meta.color} className="text-white">
      {meta.label}
    </Badge>
  );
};

export const money = (value) =>
  currencyFormatter(`${Math.round(Number(value) || 0)}`, "UZS") || "0 UZS";

export const discountLabel = (promocode) => {
  if (!promocode) return "";
  if (promocode.discountType === "percentage") {
    const cap = Number(promocode.maxDiscountAmount) > 0;
    return `${promocode.discountValue}%${cap ? ` (max ${money(promocode.maxDiscountAmount)})` : ""}`;
  }
  return money(promocode.discountValue);
};

export const usageLabel = (promocode) => {
  if (!promocode) return "";
  if (promocode.unlimited) return `${promocode.usedCount || 0} / unlimited`;
  return `${promocode.usedCount || 0} / ${promocode.usageLimit || 0}`;
};

export const scopeLabel = (promocode) => {
  if (!promocode) return "";
  const exams = promocode.exams?.length
    ? promocode.exams.join(", ")
    : "All exams";
  const modules = promocode.modules?.length
    ? ` — ${promocode.modules.join(", ")}`
    : "";
  return `${exams}${modules}`;
};

export const USAGE_STATUS_META = {
  applied: { color: "success", label: "Applied" },
  reserved: { color: "info", label: "Reserved" },
  released: { color: "secondary", label: "Released" },
};

export const AUDIT_ACTION_LABELS = {
  created: "Created",
  updated: "Edited",
  activated: "Activated",
  deactivated: "Deactivated",
  deleted: "Archived",
  restored: "Restored",
  reserved: "Reserved by candidate",
  redeemed: "Used by candidate",
  released: "Reservation released",
  usage_voided: "Usage voided",
  requested: "Requested from the till",
  request_approved: "Request approved in Telegram",
  request_rejected: "Request rejected in Telegram",
};
